import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
    selector: "sps-list-action-bar",
    templateUrl: "./sps-list-action-bar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsListActionBarComponent {
    static readonly displayName = "sps-list-action-bar";
    static readonly props = {
        itemsSelected: { type: "string | number", required: true },
        clearSelected: { event: true, type: "void", required: true },
    };

    @Input() itemsSelected: string | number;

    @Output() clearSelected = new EventEmitter<void>();

    @HostBinding("class.sps-list-action-bar-container")
    @HostBinding("class.z-stratum-bar")
    readonly _staticClassBindings = true;

    @HostBinding("class.d-none")
    get nothingSelected() {
        return !this.itemsSelected;
    }
}
